import React from "react";
import Parallax  from "./parallax.tsx";
import Projects from "./projects.tsx";
function Home() {

    return (
        <>
            <Parallax/>   
            
            <Projects/>  
        </>
    );
}   
export default Home;